import React, { useState } from 'react';

const BannerTop = () => {
    return (
        <div id="banner-top">
            <img src="/images/banner-top.png" alt="" style={{marginLeft: 'auto', marginRight: 'auto'}} />
        </div>
    );
};

export default BannerTop;